module.exports = __webpack_public_path__ + "media/images/login_logo-a6509dc7a0b08a60ebc82776ca88dba6.gif";